
import { Component, Vue } from 'vue-property-decorator';
import ButtonLang from '@/components/button/ButtonLang.vue';
// @ is an alias to /src
import store from '@/store';

@Component({
  components: {
    ButtonLang,
  },
})
export default class CommonHeaderEn extends Vue {
  private name = 'CommonHeaderEn';
  get isShow(): boolean {
    return store.getters.loaded;
  }
  get userNameEn(): string {
    return store.getters['auth/nameEn'];
  }
}
